module.exports = __webpack_public_path__ + "offer-analysis.svg?523917e72eaa95dd675ab87155a1f475";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/offer-analysis.svg
// module id = 94
// module chunks = 2